import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';
import {
  subscriptionFields,
  subscriptionDateRangeRefine,
} from '@/schema/subscriptionSchema';

export const addSchoolSchema = z
  .object({
    profileImage: z.instanceof(File).optional(),

    schoolName: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.schoolName.required)
      .min(2, VALIDATION_MESSAGES.schoolName.min)
      .max(100, VALIDATION_MESSAGES.schoolName.max)
      .regex(
        /^[a-zA-Z0-9؀-ۿ\s'.,&-]+$/,
        VALIDATION_MESSAGES.schoolName.invalid
      ),

    schoolEmail: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.schoolEmail.required)
      .min(5, VALIDATION_MESSAGES.schoolEmail.min)
      .max(100, VALIDATION_MESSAGES.schoolEmail.max)
      .refine(
        (val) =>
          /^[a-zA-Z0-9](?!.*[-_.]{2})[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/.test(
            val
          ),
        {
          message: VALIDATION_MESSAGES.schoolEmail.invalid,
        }
      ),
    countryCode: z
      .string()
      .regex(/^\+\d{1,4}$/, VALIDATION_MESSAGES.countryCode.invalid),
    mobileNumber: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.mobileNumber.required)
      .regex(/^\d{6,15}$/, VALIDATION_MESSAGES.mobileNumber.invalid),
    status: z.boolean(),
    sendInvite: z.boolean(),
    studentLimit: subscriptionFields.studentLimit,
    amount: subscriptionFields.amount,
    currency: subscriptionFields.currency,
    subscriptionStartDate: subscriptionFields.subscriptionStartDate,
    subscriptionEndDate: subscriptionFields.subscriptionEndDate,
    transactionId: subscriptionFields.transactionId,
  })
  .superRefine(subscriptionDateRangeRefine);

export type TAddSchoolFormValues = z.infer<typeof addSchoolSchema>;
